import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import formatString from "format-string-by-pattern"
import LoaderButton from "../../components/LoaderButton"
import Typography from "@material-ui/core/Typography"
import {
  Button,
  Radio,
  FormControl,
  FormLabel,
  Box,
  RadioGroup,
  FormControlLabel,
  Avatar
} from "@material-ui/core/"
import { closeUpdateAccessDialog } from "actions/update-access-dialog"
import DialogsContainerDialog from "../DialogsContainer"
import cloudinary from "cloudinary-core"
import { updateRole, removeOrgAccess } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const accessRightsFields = [
  {
    value: "Administrator",
    control: <Radio color="primary" />,
    text:
      "Top level access to moderate content, manage all members and edit organizational settings.",
    label: "Administrator",
    id: 2
  },
  {
    value: "Moderator",
    control: <Radio color="primary" />,
    text: "Access to review, edit and post media content submitted by users.",
    label: "Moderator",
    id: 3
  },
  {
    value: "User",
    control: <Radio color="primary" />,
    text:
      "General organization members that can only submit content to moderator.",
    label: "User",
    id: 4
  }
]

const UpdateAccessDialog = ({ classes }) => {
  const dispatch = useDispatch()
  const { open, data, additionalFields } = useSelector(state => ({
    open: state.updateAccessDialog.open,
    data: state.updateAccessDialog.data,
    additionalFields: state.organization.currentOrg.additionalFields
  }))
  const { user } = data
  // "user || {}"" is because user will not exist initally is will be null
  const {
    id,
    role,
    profile_image: profileImage,
    name,
    phone,
    email,
    field_values: fieldValues
  } = user || {}

  const [accessRights, setAccessRights] = useState(role)
  const [loadingUpdate, setLoadingUpdate] = useState(false)
  const [working, setWorking] = useState(false)

  const handleChangeAccessRights = e => {
    setAccessRights(e.target.value)
  }

  const handleClose = () => {
    dispatch(closeUpdateAccessDialog())
  }
  useEffect(() => {
    setAccessRights(role)
  }, [role])

  const handleUpdate = () => {
    const roleId = accessRightsFields.find(x => x.value === accessRights).id
    setLoadingUpdate(true)
    dispatch(updateRole(id, roleId))
      .then(() => {
        dispatch(openSnackBar({ message: "User role updated" }))
        setLoadingUpdate(false)
        handleClose()
      })
      .catch(() => {
        dispatch(openSnackBar({ message: "Error updating user role" }))
        setLoadingUpdate(false)
      })
  }
  const handleRemoveAccess = () => {
    setWorking(true)
    dispatch(removeOrgAccess(id))
      .then(() => {
        dispatch(openSnackBar({ message: "Removed user from organization" }))
        setWorking(false)
        handleClose()
      })
      .catch(() => {
        dispatch(
          openSnackBar({ message: "Error removing user from organization" })
        )
        setWorking(false)
      })
  }

  if (fieldValues) {
    const test = JSON.parse(fieldValues)
    test.filter(test => test.field_id === 1)
    // console.log(Array.isArray(test))
    // console.log(test)
  }

  const getFieldValue = id => {
    let val = null
    try {
      val = JSON.parse(fieldValues).filter(
        fieldValue => fieldValue.field_id === id
      )[0].value
    } catch (err) {
      val = null
    }
    return val
  }

  return (
    <DialogsContainerDialog
      open={open}
      handleClose={handleClose}
      title="Update Access"
      classes={{ dialogActions: classes.dialogActions }}
      content={
        <Box
          className={classes.updateAccessContainer}
          display="flex"
          flexDirection="column"
        >
          <Box
            display="flex"
            flexWrap="wrap"
            className={classes.informationContainer}
          >
            <Box
              display="flex"
              alignItems="center"
              className={classes.personalInformation}
            >
              <Box>
                <Avatar
                  className={classes.personPicture}
                  src={
                    profileImage &&
                    cl.url(profileImage, {
                      width: 150,
                      crop: "scale"
                    })
                  }
                />
              </Box>
              <Box className={classes.personalInformationText}>
                <Typography variant="subtitle2" className={classes.nameText}>
                  {name}
                </Typography>
                <Typography
                  className={classes.numberEmailAddiotnalFieldsText}
                  variant="subtitle2"
                >
                  {phone &&
                    formatString("(000) 000-0000", phone.replace("+1", ""))}
                </Typography>
                <Typography
                  className={classes.numberEmailAddiotnalFieldsText}
                  variant="subtitle2"
                >
                  {email}
                </Typography>
              </Box>
            </Box>
            <Box className={classes.additionalFields} order={3}>
              <Typography
                variant="subtitle2"
                className={classes.additionalFieldsTitle}
              >
                Additional Fields:
              </Typography>
              <Box display="flex" className={classes.rankSquadContainer}>
                {additionalFields &&
                  additionalFields.map(field => (
                    <Box className={classes.rankContainer} key={field.id}>
                      <Typography variant="h5" className={classes.fieldText}>
                        {field.name}
                      </Typography>
                      <Typography
                        className={classes.numberEmailAddiotnalFieldsText}
                        variant="subtitle2"
                      >
                        {fieldValues && getFieldValue(field.id)}
                      </Typography>
                    </Box>
                  ))}
              </Box>
            </Box>
          </Box>
          <Box className={classes.accessContainer}>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                <Typography className={classes.accessRightsTitle} variant="h5">
                  Access Rights
                </Typography>
              </FormLabel>
              <RadioGroup
                aria-label="rights"
                name="rights"
                value={accessRights}
                className={classes.radioPlacement}
                onChange={handleChangeAccessRights}
              >
                <Box display="flex" flexWrap="wrap">
                  {accessRightsFields.map((field, i) => {
                    const { value, control, label } = field
                    return (
                      <Box className={classes.roleContainer} key={i}>
                        <FormControlLabel
                          value={value}
                          control={control}
                          label={label}
                        />
                        <Typography
                          variant="body1"
                          className={classes.roleText}
                          color="secondary"
                        >
                          {field.text}
                        </Typography>
                      </Box>
                    )
                  })}
                </Box>
              </RadioGroup>
            </FormControl>
          </Box>
          <Box className={classes.additionalFieldsPhoneVersion} order={3}>
            <Typography
              variant="subtitle2"
              className={classes.additionalFieldsTitle}
            >
              Additional Fields:
            </Typography>
            <Box display="flex" className={classes.rankSquadContainer}>
              {additionalFields &&
                additionalFields.map(field => (
                  <Box className={classes.rankContainer} key={field.id}>
                    <Typography variant="h5" className={classes.fieldText}>
                      {field.name}
                    </Typography>
                    <Typography
                      className={classes.numberEmailAddiotnalFieldsText}
                      variant="subtitle2"
                    >
                      {fieldValues && getFieldValue(field.id)}
                    </Typography>
                  </Box>
                ))}
            </Box>
          </Box>
        </Box>
      }
      buttons={
        <Box
          className={classes.buttonsContainer}
          display="flex"
          justifyContent="center"
        >
          <Box flexGrow={1}>
            <LoaderButton
              variant="text"
              classes={{
                button: !working
                  ? classes.removeAccessButton
                  : classes.removeAccessButtonWorking,
                buttonProgress: classes.buttonProgress
              }}
              working={working}
              onClick={handleRemoveAccess}
            >
              remove access
            </LoaderButton>
          </Box>
          <Box display="flex">
            <Button
              onClick={handleClose}
              variant="text"
              className={classes.backButton}
            >
              Back
            </Button>

            <LoaderButton
              classes={{
                button: classes.updateButton
              }}
              working={loadingUpdate}
              color="primary"
              onClick={handleUpdate}
            >
              update
            </LoaderButton>
          </Box>
        </Box>
      }
    />
  )
}

export default withStyles(styles)(UpdateAccessDialog)



// WEBPACK FOOTER //
// ./src/dialogs/UpdateAccess/index.jsx